import { z } from "zod";

export const createNodeSchema = z.object({
    friendlyName: z
        .string({
            message: "Friendly name is required",
        })
        .min(1, {
            message: "Friendly name is required",
        })
        .min(3, {
            message: "Friendly name must be at least 3 characters long",
        })
        .max(16, {
            message: "Friendly name must be at most 16 characters long",
        }),
});
